"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgHourglass(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 16 16', xmlns: 'http://www.w3.org/2000/svg' }, props),
        React.createElement("path", { d: 'm10.82056 4.09265a10.67215 10.67215 0 0 1 -2.82056 3.07007 10.67178 10.67178 0 0 1 -2.8208-3.07007zm-.6659 3.82861c1.37329 1.1836 2.84522 2.85315 2.84522 4.5702v1.50854h1.00012v2h-12v-2h.99988v-1.50854c0-1.71705 1.47168-3.3866 2.84521-4.5702-1.36909-1.24682-2.84521-2.98791-2.84521-4.69726v-1.224h-.99988v-2h12v2h-1.00012v1.224c0 1.70935-1.4762 3.45032-2.84522 4.69726zm-1.87854.02967c.88037-.681 3.56995-2.91114 3.56995-4.72693v-1.20593h-7.69238v1.20593c0 1.81579 2.68994 4.04578 3.57006 4.72693-.88012.63513-3.57006 2.72461-3.57006 4.54053v.86828l3.84887-3.01794 3.84344 3.0172h.00012v-.86755c-.00005-1.81603-2.68975-3.90539-3.57-4.54052z' })));
}
exports.default = SvgHourglass;
